module.exports = __webpack_public_path__ + "img/ico_logout--wh.aef1d588.svg";